<template>
  <div class="trainlist">
    <el-row :gutter="20" v-if="totalCount" v-loading="loading">
      <el-col :xs="12" :sm="12" :md="8" :lg="6" v-for="(item,index) in data" :key="index" style="margin-top: 10px;">
        <el-card shadow="always">
          <div class="testIndex-content">
            <router-link :to="{path:'/evaluationList/evaluationListDetail',query:{id:item.id}}">
              <el-image style="width:100%; height: 200px" :src="item.athletes_photo ? imgPath+item.athletes_photo : '/image/personal/head_portrait.jpg' "></el-image>
              <p style="text-align: center;height:22px;margin-top: 8px;">
                <el-image v-for="(item,index) in item.star" :key="index" style="width:15px ; height: 15px;margin-right:3px;" src="/image/evaluationStaff/star.png"></el-image>
              </p>
              <p class="con">
                <img :src="srcValue(item.evaluator_rank_value)" class="badge" />
                <label>{{item.name}}({{item.evaluator_rank_name}})</label>
              </p>
              <p style="text-align: center;color: #000000;font-size: 14px;margin-top: 5px;height: 20px">{{item.address}}</p>
            </router-link>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <no-data v-else />
    <div class="pagination" style="margin-top: 55px;text-align: center;">
      <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="paging.limit" :total="totalCount" v-if="totalCount>20"></el-pagination>
    </div>
  </div>
</template>

<script>
import { GetUserCoachList } from '@/api/admin/common.js'
import noData from '@/views/admin/components/noData.vue'
export default {
  components: {
    noData
  },
  data() {
    return {
      iconList: ['/image/index/icon_place.png', '/image/index/icon_time.png'],
      data: [],
      totalCount: 0,
      paging: {
        limit: 20,
        page: 1
      },
      loading: false,
      imgPath: window.apiObj.apiUrl,
      msg: null
    }
  },
  created() {
    this.getList()
  },
  mounted() {
    this.searchBus.$on('SearchData', (msg) => {
      this.searchALLdata(msg)
    })
  },
  methods: {
    srcValue(status) {
      if (status == 1) return '/image/evaluationStaff/badge1.png'
      if (status == 2) return '/image/evaluationStaff/badge2.png'
      if (status == 3) return '/image/evaluationStaff/badge3.png'
    },
    getList() {
      // 考评员列表
      this.loading = true
      GetUserCoachList(Object.assign(this.paging)).then((data) => {
        var list = data.data.result
        if (list) {
          this.data = list.items
          this.totalCount = list.totalCount
          this.loading = false
        }
      })
    },
    // 考评员列表分页
    handleCurrentChange(cpage) {
      this.paging.page = cpage
      window.console.log(this.paging)
      window.console.log(this.msg)
      this.loading = true
      GetUserCoachList(Object.assign(this.msg, this.paging)).then((data) => {
        var list = data.data.result
        if (list) {
          this.data = list.items
          this.loading = false
        }
      })
    },
    // 考评员列表搜索
    searchALLdata(msg) {
      this.msg = msg
      window.console.log(this.msg)
      this.paging.page = 1
      this.loading = true
      GetUserCoachList(Object.assign(msg, this.paging)).then((data) => {
        var list = data.data.result
        if (list) {
          this.data = list.items
          this.totalCount = list.totalCount
          this.loading = false
        }
      })
    }
  },
  beforeDestroy() {
    this.searchBus.$off('SearchData')
  }
}
</script>

<style lang="less" scoped>
.trainlist {
  .el-card__body {
    padding: 0;
    .con {
      position: relative;
      border-bottom: 1px solid #c4c4c4;
      color: #4e4e4e;
      text-align: center;
      padding: 20px 0;
      .badge {
        position: absolute;
        top: 8px;
        left: 13px;
        width: 23px;
        height: 23px;
        margin-right: 3px;
      }
      label {
        position: absolute;
        top: 10px;
        left: 42px;
      }
    }
    .con {
      text-align: center;
      padding: 24px 0 15px 0;
      color: #000000;
      font-size: 14px;
    }
  }
}
@media screen and (max-width: 767px) {
  .trainlist {
    .el-card__body {
      .con {
        padding: 28px 0;
      }
    }
  }
}
</style>
